import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import ReactCountryFlag from "react-country-flag";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import localeInfo from "../../../data/locale-info.json";

import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const Footer = ({ localeData, acToggleLanguageDialogue, acOnLanguageChanged }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleHelpClick = () => {
    window.open("https://love.spiking.com/hc/en-us/requests/new", "_blank");
  };

  const handlePrivacyClick = () => {
    window.open("https://spiking.com/privacy", "_blank");
  };

  const handleTermsClick = () => {
    window.open("https://spiking.com/terms", "_blank");
  };
  return (
    <Paper className="flex items-center justify-between fixed bottom-0 w-full px-2 md:px-10 py-4 h-[50px]">
      <div>
        <div
          className={`flex items-center gap-x-2 cursor-pointer p-2 rounded ${
            open && "bg-[#E5F2FF] border-[#0D8BFF] border-[1px]"
          }`}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <ReactCountryFlag
            countryCode={localeData.countryCode}
            svg
            style={{
              width: "24px",
              height: "24px",
            }}
            title={localeData.countryCode}
          />
          <Typography variant="body2" color="textPrimary">
            {localeData.language}
          </Typography>
          {!open ? (
            <ArrowDropDownIcon className="!text-[#6B778C]" />
          ) : (
            <ArrowDropUpIcon className="!text-[#6B778C]" />
          )}
        </div>
        <Menu
          id="portfolio-menu"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          PaperProps={{
            style: {
              borderRadius: 10,
              padding: 4,
            },
          }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={open}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "portfolio-button",
          }}
        >
          {localeInfo.map((locale, index) => (
            <MenuItem
              onClick={() => {
                acOnLanguageChanged(locale);
                acToggleLanguageDialogue();
              }}
              index={index}
              className="!py-2 !w-[180px]"
            >
              <div className="mr-3 cursor-pointer">
                <ReactCountryFlag
                  countryCode={locale.countryCode}
                  svg
                  style={{
                    width: "36px",
                    height: "24px",
                    borderRadius: 3,
                  }}
                  title={locale.countryCode}
                  // onClick={() => props.onLanguageChange(locale)}
                />
              </div>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                // onClick={() => props.onLanguageChange(locale)}
                // className={classes.languageBlock}
              >
                <span class="notranslate">{locale.language}</span>
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      </div>
      <div className="flex items-center gap-x-4">
        <Typography
          className="!text-xs cursor-pointer"
          color="textSecondary"
          onClick={handleHelpClick}
        >
          <span class="notranslate">
            <FormattedMessage id="login.help" />
          </span>
        </Typography>
        <Typography
          className="!text-xs cursor-pointer"
          color="textSecondary"
          onClick={handlePrivacyClick}
        >
          <span class="notranslate">
            <FormattedMessage id="login.privacy" />
          </span>
        </Typography>
        <Typography
          className="!text-xs cursor-pointer"
          color="textSecondary"
          onClick={handleTermsClick}
        >
          <span class="notranslate">
            <FormattedMessage id="login.terms" />
          </span>
        </Typography>
      </div>
    </Paper>
  );
};

const mapStateToProps = (state) => {
  return {
    localeData: state.login.localeData,
    toggleLanguageDialogue: state.login.toggleLanguageDialogue,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    acToggleLanguageDialogue: () => dispatch(actions.toggleLanguageDialogue()),
    acOnLanguageChanged: (localeData) =>
      dispatch(actions.changeLanguage(localeData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
